export const name = "TO_JSON_STRING";
export const summary = `Converts a SQL value to a JSON-formatted \`STRING\` value.`;
export const reference = `
## TO_JSON_STRING

Converts a SQL value to a JSON-formatted \`STRING\` value.

\`\`\`
TO_JSON_STRING(value[, pretty_print])
\`\`\`

### Description

Converts a SQL value to a JSON-formatted \`STRING\` value.

Arguments:

- \`value\`: A SQL value. You can review the GoogleSQL data types that this function supports and their JSON encodings here.
- \`pretty_print\`: Optional boolean parameter. If \`pretty_print\` is \`true\`, the returned value is formatted for easy readability.


### Return type

A JSON-formatted \`STRING\`


### Examples

The following query converts a \`STRUCT\` value to a JSON-formatted string:



\`\`\`
SELECT TO_JSON_STRING(STRUCT(1 AS id, [10,20] AS coordinates)) AS json_data

/*--------------------------------*
 | json_data |
 +--------------------------------+
 | {"id":1,"coordinates":[10,20]} |
 *--------------------------------*/
\`\`\`

The following query converts a \`STRUCT\` value to a JSON-formatted string that is easy to read:



\`\`\`
SELECT TO_JSON_STRING(STRUCT(1 AS id, [10,20] AS coordinates), true) AS json_data

/*--------------------*
 | json_data |
 +--------------------+
 | { |
 | "id": 1, |
 | "coordinates": [ |
 | 10, |
 | 20 |
 | ] |
 | } |
 *--------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/json_functions
`;
